import { gql } from '@apollo/client';
import { IGraphQLOperationList } from '../../../../infra/graphql/interfaces/operation.interface';

const names = ['me'];

const operation = gql`
  query getMe {
    ${names[0]}{
      exp
      user {
        login
        name
        userName
        identificacao
        email
        unidade
        grupo
        nomeGrupo
        coordenadoria
        isContribuinte
        isCplanf
        isCoordenador
        isFiscal
        isDev
        isSAT
      }
      menu {
        nome
        url
        menuID
        arvoreDeMenu {
          nome
          url
          menuID
          arvoreDeMenu {
            nome
            url
            menuID
          }
        }
      }
    }
  }
`;

export const GET_ME: IGraphQLOperationList = { names, operation };
